<template>
  <div class="hello">
    <div id="heNan"></div>
  </div>
</template>
<script>
import "echarts-gl";
import { getAction } from "../api/api";
import { MapData } from "../api/url";
// import "echarts/map/js/province/henan.js";
import "../../public/map/js/province/henan.js";
// import chinaPng from '../assets/china.png'
export default {
  name: "HelloWorld",
  components: {},
  data() {
    return {
      namemap: {},
      dataArr: [],
      LinShiData: [],
      IsFirst: true,
      CountryData: [],
      ForeachData: [],
      coursel: {},
    };
  },
  props: {},
  created() {
    this.loadData();
  },
  mounted() {},
  watch: {},
  methods: {
    loadData() {
      let data = {
        action: "Get_CityMap",
      };
      getAction(MapData, data).then((res) => {
        this.CityData = res;
        setTimeout(() => {
          this.getChart();
        }, 500);
      });
    },
    getChart() {
      this.ResetData();
    },
    Stop() {
      clearInterval(this.coursel);
    },

    ResetData() {
      let data = [];
      var ProvinceData = [
        {
          name: "郑州",
          value: ["113.65", "34.76"],
        },
        {
          name: "洛阳",
          value: ["112.44", "34.7"],
        },
        {
          name: "开封",
          value: ["114.35", "34.79"],
        },
        {
          name: "平顶山",
          value: ["113.29", "33.75"],
        },
        {
          name: "焦作",
          value: ["113.21	", "35.24"],
        },
        {
          name: "鹤壁",
          value: ["114.17", "35.9"],
        },
        {
          name: "新乡",

          value: ["113.85", "35.31"],
        },
        {
          name: "安阳",
          value: ["114.35", "36.1"],
        },
        {
          name: "濮阳",
          value: ["114.98", "35.71"],
        },
        {
          name: "许昌",
          value: ["113.81", "34.02"],
        },
        {
          name: "漯河",
          value: ["114.02", "33.56"],
        },
        {
          name: "三门峡",
          value: ["111.19", "34.76"],
        },
        {
          name: "南阳",
          value: ["112.53", "33.01"],
        },
        {
          name: "商丘",
          value: ["115.65", "34.44"],
        },
        {
          name: "信阳",
          value: ["114.08", "32.13"],
        },
        {
          name: "周口",
          value: ["114.63", "33.63"],
        },
        {
          name: "驻马店",
          value: ["114.02", "32.98"],
        },

        {
          name: "济源",
          value: ["112.57", "35.08"],
        },
        {
          name: "汝州",
          value: ["112.84301", "34.16135"],
        },
        {
          name: "滑县",
          value: ["114.52", "35.57"],
        },
        {
          name: "长垣县",
          value: ["114.67", "35.19"],
        },
        {
          name: "邓州市",
          value: ["112.08", "32.68"],
        },
        {
          name: "永城市",
          value: ["116.37", "33.94"],
        },
        {
          name: "固始县",
          value: ["115.68", "32.17"],
        },
        {
          name: "鹿邑县",
          value: ["115.48", "33.86"],
        },
        {
          name: "新蔡县",
          value: ["114.97", "32.75	"],
        },

        {
          name: "巩义",
          value: ["113.022", "34.74794"],
        },
        {
          name: "兰考",
          value: ["114.81961", "34.8235"],
        },
      ];
      this.CityData.forEach((item) => {
        ProvinceData.forEach((items) => {
          if (item.name.indexOf(items.name) !== -1) {
            let oneCityData = {
              value: items.value,
              name: items.name,
              data: {
                jscg: item.Achievements,
                xq: item.Demand,
                Rc: item.Personnel,
                Organization: item.Organization,
                TO: item.TechnologyOrganization, //转移示范机构
                un: item.un,
                International: item.International,
              },
            };
            data.push(oneCityData);
          }
        });
      });
      let i = 0;
      for (var j = 0; j < 2; j++) {
        this.ForeachData[j] = data[i];
        i++;
        // ForeachData
      }
      this.initEcharts();
      this.coursel = setInterval(() => {
        setTimeout(() => {
          this.ForeachData = [];
          for (var j = 0; j < 2; j++) {
            if (i === 30) {
              i = 0;
            }
            this.ForeachData[j] = data[i];
            i++;
            // ForeachData
          }
          this.initEcharts();
        }, 0);
      }, 5000);
    },
    initEcharts() {
      var HeNanChart = this.$echarts.init(document.getElementById("heNan"));

	  var hr = new Image();
	  hr.src = "data:image/png;base64,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";
		  
	  var option = {
        title: {
          text: "",
          left: "center",
        },
        
        geo: [{
          // 这个是重点配置区
          map: "河南", // 表示河南地图
          roam: false,
          // layoutCenter: ["50%", "50%"],
          // layoutSize: "100%",
		  zoom: 1,
		  padding: 0,
		  // left: "15%",
		  top: "2%",
          label: {
            normal: {
              show: true, // 是否显示对应地名

              textStyle: {
                color: "#333",
              },
            },
          },
          itemStyle: {
            normal: {
              borderWidth: 2, //区域边框宽度
              borderColor: "#87B6FF", //区域边框颜色
              areaColor: "#fff", //区域颜色
              shadowColor: "#87B6FF",
              shadowBlur: 5,
            },

            emphasis: {
              borderWidth: 0.5,
              borderColor: "#FF8121",
              areaColor: "#FFEEE5",
              shadowColor: "#FF8121",
              shadowBlur: 4,
            },
          },
        }],
		
        series: [			
          {
            type: "lines",
            zlevel: 2,
            effect: {
              show: true,
              period: 4,
              trailLength: 0.02,
              symbol: "arrow",
              symbolSize: 5,
            },
            lineStyle: {
              normal: {
                width: 1,
                opacity: 0.6,
                curveness: 0.2,
              },
            },
            tooltip: {
              trigger: "item",
            },
            data: [],
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            zlevel: 5,
            label: {
              normal: {
                show: true,
                position: "bottom", //显示位置
                offset: [0, 0], //偏移设置
                padding: [10, 10],
                backgroundColor: "rgba(47, 101, 194, 0.7)",
                // image: require("../assets/bg.png"),
                borderRadius: 10,
                formatter: function (params) {
                  var name = params.name;
                  var value = params.data.data;
				  
				  if(value.jscg > 0 || value.xq > 0 || value.Rc > 0)
				  {
					  var text = '{fname|' + name + '}\n\n{flabel2|' + value.jscg + '}{flabel2|' + value.xq + '}{flabel2|' + value.Rc + '}\n{flabel1|技术成果}{flabel1|技术需求}{flabel1|高层次人才}\n\n';
					  
					  if(value.Organization > 0 || value.TO > 0 || value.un > 0 || value.International > 0){
						text = text + '{flabel3|}{flabel3|}{flabel3|}\n\n';
					  }
					  
					  if(value.Organization > 0)
					  {
						text = text + '{flabel|河南省新型研发机构：}{fvalue|' + value.Organization + '}\n';
					  }
					  if(value.TO > 0)
					  {
						text = text + '{flabel|河南省技术转移示范机构：}{fvalue|' + value.TO + '}\n';
					  }
					  if(value.un > 0)
					  {
						text = text + '{flabel|河南省产业技术创新战略联盟：}{fvalue|' + value.un + '}\n';
					  }
					  if(value.International > 0)
					  {
						text = text + '{flabel|国际技术转移机构：}{fvalue|' + value.International + '}\n';
					  }

					 return text.trimRight('\n');
				  }
				  else{
				  	  return "";
				  }
                },
                rich: {
                  show: false,
                  backgroundColor: "rgba(47, 101, 194, 0.7)",
                  fnameicon: {
                    width: 24,
                    height: 16,
                    backgroundColor: {
                      // image: require("../assets/titleicon.png"),
                    },
                  },
                  fname: {
                    color: "#23FFFC",
                    fontWeight: 500,
                    fontSize: 16,
                  },
                  flabel: {
                    color: "#fff",
                    fontWeight: 400,
                    fontSize: 12,
                    width: 65,
                    padding: 5,
                  },
				  flabel1: {
				    color: "#fff",
				  	align: "center",
				    fontWeight: 400,
				    fontSize: 12,
				    width: 65,
				    padding: 5,
				  },
				  flabel2: {
				    color: "#fff",
				  	align: "center",
				    fontWeight: 400,
				    fontSize: 18,
				    width: 65,
				    padding: 5,
				  },
				  flabel3: {
					width: 70,
					height: 1,
					align: "center",
				  	backgroundColor: { image:hr  },
				  },
                  fvalue: {
                    color: "#ffffff",
                    fontWeight: "bold",
                    fontSize: 14,
                    align: "right",
                  },
                },
              },
              emphasis: {
                show: true,
                position: "bottom", //显示位置
                offset: [0, 0], //偏移设置
                padding: [10, 10],
                backgroundColor: "rgba(16, 23, 35, .7)",
                // image: require("../assets/bg.png"),
                borderRadius: 10,
                formatter: function (params) {
                  var name = params.name;
                  var value = params.data.data;
				  
                  if(value.jscg > 0 || value.xq > 0 || value.Rc > 0)
				  {
					  var text = '{fname|' + name + '}\n\n{flabel2|' + value.jscg + '}{flabel2|' + value.xq + '}{flabel2|' + value.Rc + '}\n{flabel1|技术成果}{flabel1|技术需求}{flabel1|高层次人才}\n\n';
					  
					  if(value.Organization > 0 || value.TO > 0 || value.un > 0 || value.International > 0){
						  text = text + '{flabel3|}{flabel3|}{flabel3|}\n\n';
					  }
					  
					  if(value.Organization > 0)
					  {
						text = text + '{flabel|河南省新型研发机构：}{fvalue|' + value.Organization + '}\n';
					  }
					  if(value.TO > 0)
					  {
						text = text + '{flabel|河南省技术转移示范机构：}{fvalue|' + value.TO + '}\n';
					  }
					  if(value.un > 0)
					  {
						text = text + '{flabel|河南省产业技术创新战略联盟：}{fvalue|' + value.un + '}\n';
					  }
					  if(value.International > 0)
					  {
						text = text + '{flabel|国际技术转移机构：}{fvalue|' + value.International + '}\n';
					  }
					
					 return text.trimRight('\n');
				 
				  }
				  else{
					  return "";
				  }
                },
                rich: {
                  backgroundColor: "rgba(47, 101, 194, 0.7)",
                  fnameicon: {
                    width: 24,
                    height: 16,
                    backgroundColor: {
                      // image: require("../assets/titleicon.png"),
                    },
                  },
                  fname: {
                    color: "#FF8121",
                    fontWeight: 500,
                    fontSize: 16,
                  },
                  flabel: {
                    color: "#fff",
                    fontWeight: 400,
                    fontSize: 12,
                    width: 65,
                    padding: 5,
                  },
				  flabel1: {
				    color: "#fff",
					align: "center",
				    fontWeight: 400,
				    fontSize: 12,
				    width: 65,
				    padding: 5,
				  },
				  flabel2: {
				    color: "#fff",
				  	align: "center",
				    fontWeight: 400,
				    fontSize: 18,
				    width: 65,
				    padding: 5,
				  },
				  flabel3: {
					width: 70,
					height: 1,
					align: "center",
				  	backgroundColor: { image:hr  },
				  },
                  fvalue: {
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 14,
                    align: "right",
                  },
                },
              },
            },
            data: this.ForeachData,
          },
        ],
      };
      HeNanChart.setOption(option);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
#heNan {
  height: 58.25rem;
  width: 100rem;
  margin: -30rem auto 0;
}
</style>
